import isEmpty from '../helpers/isEmpty'
//------------------------------
// get populated skill increase
//------------------------------
export default function getPopulatedSkillIncrease(cur_no_adjs, kb) {

  if (isEmpty(cur_no_adjs) || isEmpty(kb)) return null

  const incr = 'Cur No Adjs (' + cur_no_adjs + ') - KB (' + kb + ') + 1'
  // console.log('increase = ', incr)
  return incr
}
